import styled from 'styled-components'

export const AppContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(
    to ${props => props.direction},
    ${props => props.color1},
    ${props => props.color2}
  );
  font-family: 'Roboto';
`

export const Heading = styled.h1`
  color: #ffffff;
  margin-bottom: 20px;
`

export const DirectionList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  margin-bottom: 25px;
`

export const ColorsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 20px;
`

export const ColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ColorInput = styled.input`
  width: 60px;
  height: 40px;
  border: none;
  background: transparent;
  cursor: pointer;
`

export const ColorValue = styled.p`
  color: #ffffff;
  margin-bottom: 8px;
`

export const GenerateButton = styled.button`
  background-color: #00c9b7;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 8px 20px;
  cursor: pointer;
  font-weight: bold;
`
